export const INIT_INVENTORY = 'inventory/init';
export const INIT_INVENTORY_SUCCESS = 'inventory/init/success';
export const INIT_INVENTORY_ERROR = 'inventory/init/error';
